
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/material-ui/all-components",
      function () {
        return require("private-next-pages/material-ui/all-components/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/material-ui/all-components"])
      });
    }
  